import { POLICY_COMPANY_HOLIDAYS } from '../data/companyHolidaysPolicy';

function startOfDayLocal(d: Date): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

/** Parse YYYY-MM-DD as a local calendar date (avoids UTC shift from date-fns parse). */
export function parseCalendarYmd(ymd: string): Date {
  const parts = ymd.trim().split('-').map(Number);
  const y = parts[0];
  const m = parts[1];
  const d = parts[2];
  if (!y || !m || !d) throw new Error(`Invalid calendar date: ${ymd}`);
  return startOfDayLocal(new Date(y, m - 1, d));
}

export type MergeableHoliday = { id: string; name: string; date: string };

/**
 * Policy holidays are always the baseline. Firestore rows override by calendar date
 * (name edits / same-day updates) and may add extra dates. This avoids "partial"
 * saves hiding the rest of the year on the calendar and in admin.
 */
export function mergeHolidaysWithPolicy(raw: MergeableHoliday[] | undefined | null): MergeableHoliday[] {
  const validRaw = Array.isArray(raw)
    ? raw.filter(h => h && typeof h.id === 'string' && typeof h.name === 'string' && typeof h.date === 'string')
    : [];
  const byDate = new Map<string, MergeableHoliday>();
  for (const h of POLICY_COMPANY_HOLIDAYS) {
    byDate.set(h.date, { id: h.id, name: h.name, date: h.date });
  }
  for (const h of validRaw) {
    const existing = byDate.get(h.date);
    if (existing) {
      byDate.set(h.date, {
        id: h.id || existing.id,
        name: h.name || existing.name,
        date: h.date,
      });
    } else {
      byDate.set(h.date, { id: h.id, name: h.name, date: h.date });
    }
  }
  return Array.from(byDate.values()).sort((a, b) => a.date.localeCompare(b.date) || a.id.localeCompare(b.id));
}
